import { AffectedProductStatus } from './spotlightDetails.types';

export function resolveEffectiveStatus(
  primaryStatus: AffectedProductStatus | null | undefined,
  fallbackStatus: AffectedProductStatus | null | undefined
): AffectedProductStatus {
  return primaryStatus ?? fallbackStatus ?? AffectedProductStatus.UNPATCHED;
}
